module.exports = __webpack_public_path__ + "assets/img/1.79d04804.png";